import { render, staticRenderFns } from "./TakenIpulseSection.vue?vue&type=template&id=5eaa1d22&"
import script from "./TakenIpulseSection.vue?vue&type=script&lang=ts&"
export * from "./TakenIpulseSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports